(function($) {
    $( '.nav-primary .hamburger' ).click(function(){
		$(this).toggleClass('is-active');
    });
    $('.archives-wrapper .sym').on('click', function(e){
      if( $(this).parent().parent().hasClass('expand')){
        $(this).parent().parent().removeClass('expand');
        $(this).html('+');
      }else{
        if($('.archive-year').parent().hasClass('expand')){
          $('.archive-year').parent().removeClass('expand');
          $('.archives-wrapper .sym').html('+');
        }
        $(this).parent().parent().addClass('expand');
        $(this).html('-');
      }
    })
      var swiper2 = new Swiper(".mySwiper2", {
        loop: true,
        spaceBetween: 2,
        slidesPerView: 1,
        slidesPerGroup: 1,
        effect:'fade',
        fadeEffect: {
          crossFade: false
        },
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      var headline = new Swiper('.headline', {
        spaceBetween: 1,
        centeredSlides: true,
        speed: 12000,
        autoplay: {
          delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove:true,
        disableOnInteraction: true
      });
      
      $('.headline').on('mouseenter', function(e){
        headline.autoplay.stop();
        console.log('slider stopped');
      });
      $('.headline').on('mouseleave', function(e){
        headline.autoplay.start();
        console.log('slider started again');
      });

      $('.gallery-images').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
              enabled:true
            }
        });
    });

    var btn = $('#totopbutton');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });
    
    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });
  $(window).on("resize", function(){
    if($(window).width() <= 768){
      var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
      var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
      var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 24;
      $('#menu-header-menu').css('top',menu_top_pos + 'px');
    }
    if($(window).width() <= 425){
      var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
      var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
      var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 17;
      $('#menu-header-menu').css('top',menu_top_pos + 'px');
    }
    if($(window).width() <= 375){
      var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
      var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
      var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 20;
      $('#menu-header-menu').css('top',menu_top_pos + 'px');
    }
    if($(window).width() <= 320){
      var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
      var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
      var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 20;
      $('#menu-header-menu').css('top',menu_top_pos + 'px');
    }
  });
  if($(window).width() <= 768){
    var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
    var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
    var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 24;
    $('#menu-header-menu').css('top',menu_top_pos + 'px');
  }
  if($(window).width() <= 425){
    var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
    var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
    var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 17;
    $('#menu-header-menu').css('top',menu_top_pos + 'px');
  }
  if($(window).width() <= 375){
    var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
    var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
    var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 20;
    $('#menu-header-menu').css('top',menu_top_pos + 'px');
  }
  if($(window).width() <= 320){
    var hamburger_post_el = $('#genesis-nav-primary').find('.hamburger-inner').offset();
    var hamburger_height_el = $('#genesis-nav-primary').find('.hamburger-inner').height();
    var menu_top_pos = hamburger_post_el.top + hamburger_height_el + 20;
    $('#menu-header-menu').css('top',menu_top_pos + 'px');
  }
})(jQuery);